import { Button, Stack } from '@mui/material';
import SaveIcon from '@mui/icons-material/Save';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import { SerializedError } from '@reduxjs/toolkit';
import { FetchBaseQueryError } from '@reduxjs/toolkit/query';
import ErrorTypography from '../../../shared/ErrorTypography/ErrorTypography';
import { Trans } from 'react-i18next';
import { RunButton } from './RunButton';
import UndoButton from './UndoButton';

type Props = {
  onSave: () => void;
  onRun: () => void;
  onStop: () => void;
  onUndo: () => void;
  undoDisabled: boolean;
  saveError: FetchBaseQueryError | SerializedError | undefined;
  saveIsLoading: boolean;
  pid: string;
};

const ControlNavigationBar = ({onUndo, onSave, onRun, onStop, undoDisabled, saveError, saveIsLoading, pid }: Props): JSX.Element => {
  return (
    <Stack display={'flex'} justifyContent={'end'} direction={'row'} spacing={2}>
      {saveError && <ErrorTypography message={'Could not Save Pipeline'} />}
      <div className='run-button'>
        <RunButton onRun={onRun} onStop={onStop} pid={pid} ></RunButton>
      </div>
      <UndoButton onUndo={onUndo} disabled={undoDisabled}></UndoButton>
      <div className='save-button'>
        <Button variant={'contained'} startIcon={<SaveIcon />} onClick={onSave} disabled={saveIsLoading}>
          <Trans>Save</Trans>
        </Button>
      </div>
    </Stack>
  );
};

export default ControlNavigationBar;
